import React, { useMemo, useState } from 'react';
import { Form, InputNumber, Collapse, Typography } from 'antd';
import { currencyInputProps, decimalInputProps } from '../../../utils/numberInputMask';
import { simularEtanolGasolina, formatBRL, formatPercent } from '../../../utils/simuladores';
import SimuladorResultado from './SimuladorResultado';

const { Text } = Typography;

function EtanolGasolinaForm() {
    const [values, setValues] = useState({
        precoEtanol: null,
        precoGasolina: null,
        kmLEtanol: null,
        kmLGasolina: null,
    });

    const resultado = useMemo(() => simularEtanolGasolina(values), [values]);

    const onChange = (field) => (val) => {
        setValues((prev) => ({ ...prev, [field]: val }));
    };

    const stats = resultado
        ? [
            { title: 'Etanol / gasolina', value: formatPercent(resultado.razaoPct) },
            { title: 'Limite (regra)', value: formatPercent(resultado.limitePct, 0) },
            ...(resultado.modo === 'consumo'
                ? [
                    { title: 'Custo/km etanol', value: formatBRL(resultado.custoKmEtanol) },
                    { title: 'Custo/km gasolina', value: formatBRL(resultado.custoKmGasolina) },
                ]
                : []),
        ]
        : [];

    return (
        <div className="simulador-form">
            <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
                Sem o consumo do carro, usamos a regra clássica: etanol costuma valer se custar até 70% da gasolina.
            </Text>
            <Form layout="vertical">
                <Form.Item label="Preço do etanol (R$/L)">
                    <InputNumber {...currencyInputProps({ min: 0 })} value={values.precoEtanol} onChange={onChange('precoEtanol')} />
                </Form.Item>
                <Form.Item label="Preço da gasolina (R$/L)">
                    <InputNumber {...currencyInputProps({ min: 0 })} value={values.precoGasolina} onChange={onChange('precoGasolina')} />
                </Form.Item>

                <Collapse
                    ghost
                    items={[{
                        key: 'consumo',
                        label: 'Consumo do meu carro (opcional)',
                        children: (
                            <>
                                <Form.Item label="Km por litro no etanol">
                                    <InputNumber
                                        {...decimalInputProps(1, { min: 0 })}
                                        value={values.kmLEtanol}
                                        onChange={onChange('kmLEtanol')}
                                    />
                                </Form.Item>
                                <Form.Item label="Km por litro na gasolina">
                                    <InputNumber
                                        {...decimalInputProps(1, { min: 0 })}
                                        value={values.kmLGasolina}
                                        onChange={onChange('kmLGasolina')}
                                    />
                                </Form.Item>
                            </>
                        ),
                    }]}
                />
            </Form>

            {resultado && <SimuladorResultado veredicto={resultado.veredicto} stats={stats} />}
        </div>
    );
}

export default EtanolGasolinaForm;
